var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "invoice-settings" },
    [
      _c(
        "vs-row",
        [
          _c(
            "vs-col",
            {
              attrs: {
                "vs-justify": "center",
                "vs-align": "center",
                "vs-w": "12",
              },
            },
            [
              _c("div", { staticClass: "table-title" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("dash.settings.invoices.title"))),
                ]),
              ]),
              _vm.noInvoice
                ? _c(
                    "vs-alert",
                    { attrs: { active: "true", color: "#842993" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("dash.settings.invoices.noinvoices")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              !_vm.noInvoice
                ? _c("component-table", {
                    attrs: {
                      gridData: _vm.gridData,
                      columns: _vm.gridColumns,
                      name: "invoice",
                    },
                    on: { "action-clicked": _vm.download },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }